import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Configuration for development
    gamesCasino, // Casino games configuration
    profile, // User profile configuration
    providersCasino, // Casino providers configuration
} from 'config/config'; // Importing various configurations

/**
 * Class representing the view for machine products.
 */
export default class tableMachineProductsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        var list1 = {
            // Configuration for the double list component
            view: 'dbllist',
            id: 'dbllist',
            list: {
                height: 0, // Height of the list
                scroll: true, // Enable scrolling
            },
            labelLeft: _('Productos no agregados'), // Left label
            labelRight: _('Productos Agregados'), // Right label
            data: [], // Initial data
        };

        return {
            // Main layout configuration
            view: 'form',
            id: 'f1',
            rows: [
                {
                    view: 'forminput', // Input field for the form
                    name: 'access', // Name of the input
                    body: list1, // Body of the input
                    labelWidth: 140, // Width of the label
                    labelAlign: 'right', // Label alignment
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        var values = ''; // Variable to hold product values
        const cur_user = this.getParam('user', true); // Get current user parameter

        // Event listener for filtering machine products
        this.on(this.app, 'machineProducts:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for API request

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format dateFrom
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format dateTo
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }

            $$('dbllist').$$('left').clearAll(); // Clear left list
            $$('dbllist').setValue([]); // Reset selected values
            webix // AJAX request to fetch machine products
                .ajax()
                .get(devConfig.geturlApi() + 'MachineProducts/GetGroupMachineProducts', string1, {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handling
                        webix.message('Error! ');
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handling
                        var data = JSON.parse(text); // Parse response data
                        if (!data.HasError) {
                            // Check for errors
                            $$('dbllist').$$('left').clearAll(); // Clear left list
                            $$('dbllist').setValue([]); // Reset selected values
                            $$('dbllist').parse(data.Data.ExcludedProductsList); // Parse excluded products
                            $$('dbllist').setValue(data.Data.IncludedProductsList); // Set included products
                            values = data.Data.IncludedProductsList; // Store included products
                        } else {
                            webix.message('Error! '); // Show error message
                        }
                    },
                });
        });

        // Event listener for changes in the double list
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            var array1 = values.split(','); // Split current values
            var array2 = $$('dbllist').getValue().split(','); // Split new values
            var arrayAgregados = []; // Array for added products
            var arrayEliminados = []; // Array for removed products

            array2.forEach(function (obj) {
                // Check for added products
                var found = array1.find(function (element) {
                    return element == obj; // Find if product was already included
                });
                if (found == undefined) {
                    // If not found, it's added
                    arrayAgregados.push(obj);
                }
            });

            array1.forEach(function (obj) {
                // Check for removed products
                var found = array2.find(function (element) {
                    return element == obj; // Find if product is still included
                });
                if (found == undefined) {
                    // If not found, it's removed
                    arrayEliminados.push(obj);
                }
            });

            values = $$('dbllist').getValue(); // Update values with current selection
            webix // AJAX request to save changes
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(
                    devConfig.geturlApi() + 'MachineProducts/SaveGroupMachineProducts',
                    '{"IdMachine":"' +
                        cur_user +
                        '","IncludedProductsList":"' +
                        arrayAgregados +
                        '","ExcludedProductsList":"' +
                        arrayEliminados +
                        '"}',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            // Error handling
                            webix.message(_('Error! '));
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Success handling
                            var data = JSON.parse(text); // Parse response data
                            if (!data.HasError) {
                                // Check for errors
                                webix.message(_('Producto Máquina Editado')); // Show success message
                            } else {
                                webix.message(_('Error! ')); // Show error message
                            }
                        },
                    },
                );
        });
    }
}

// FILE DOCUMENTED
